import { Component } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MenuController, NavController } from "@ionic/angular";
import { DateTime } from 'luxon';
import { ValidDate } from "../../helpers/valid-date.validator";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {

  form: UntypedFormGroup;

  constructor(
    private menuController: MenuController,
    private navCtrl: NavController,
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
  ) {
    this.menuController.enable(false);
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      cpf: ['', [Validators.required, Validators.minLength(14)]],
      birth_date: ['', [Validators.required, Validators.minLength(10), ValidDate('dd/mm/yyyy')]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      whatsapp: ['', [Validators.required]],
      confirm: [false, [Validators.required, Validators.requiredTrue]]
    })
    this.form = this.formBuilder.group({
      name: ['joaosilva', [Validators.required]],
      cpf: ['999.999.999-99', [Validators.required, Validators.minLength(14)]],
      birth_date: ['01/01/1990', [Validators.required, Validators.minLength(10), ValidDate('dd/mm/yyyy')]],
      email: ['joaosilva@gmail.com', [Validators.required, Validators.email]],
      password: ['jalksjdflajsdf', [Validators.required, Validators.minLength(6)]],
      whatsapp: ['99999999999', [Validators.required]],
      confirm: [true, [Validators.required, Validators.requiredTrue]]
    })
  }

  register() {
    this.form.markAllAsTouched()
    if (this.form.invalid) return

    const payload = this.form.value
    payload.birth_date = DateTime
      .fromFormat(payload.birth_date, 'dd/mm/yyyy')
      .toFormat('yyyy-mm-dd')

    this.authService
      .register(this.form.value)
      .subscribe({
        next: () => this.login(),
        error: err => {
          if (err.messages) {
            const errors = err.messages.join('<br/>')
          }
        }
      })

  }

  login() {
    // const payload = this.form.value
    // this.authService
    //   .login(payload)
    //   .subscribe({
    //     next: () => this.navCtrl.navigateRoot('/dashboard'),
    //     error: (error) => console.error(error)
    //   })
  }

}
